/** Minimal gold lotus mark — echoes the brand logo. */
export function Lotus({ className = '', size = 30 }: { className?: string; size?: number }) {
  return (
    <svg
      viewBox="0 0 64 48"
      width={size}
      height={(size * 48) / 64}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
      aria-hidden
    >
      <path d="M32 44 C22 30 8 26 4 24 C12 36 20 40 32 44 Z" />
      <path d="M32 44 C42 30 56 26 60 24 C52 36 44 40 32 44 Z" />
      <path d="M32 44 C26 28 22 16 20 8 C30 18 34 32 32 44 Z" />
      <path d="M32 44 C38 28 42 16 44 8 C34 18 30 32 32 44 Z" />
      <path d="M32 44 C30 26 32 12 32 4 C34 12 34 26 32 44 Z" />
    </svg>
  );
}
